import BaseModel from 'volta/models/base-model';
import { _normalize, collectionCommand } from 'volta/utils/api';

import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import type SkuModel from 'volta/models/sku';
import type { ICopyTransactionsResult, ICopyTransactionsToCmd, IUpdateManyTransactionsCmd } from './types/transaction';
import type { ICmdResult } from 'volta/utils/api/jsonapi-types';

export const TransactionResourceName = {
  singular: 'transaction',
  plural: 'transactions'
};

export const Events = {
  TransactionsByDayUpdated: 'TransactionsByDayUpdated'
};

export const Queries = {
  OrderTypes: 'orderTypes'
};

export const Commands = {
  CopyTransactionsTo: 'CopyTransactionsTo',
  UpdateManyTransactions: 'UpdateManyTransactions'
};

export default class Transaction extends BaseModel {
  // TODO - Remove when investigation on
  // why it only disappears on Planning/Transaction model is done
  static modelName = 'transaction';

  // Collection Commands
  // ~~~~

  static updateManyTransactions = collectionCommand<
    IUpdateManyTransactionsCmd,
    Transaction[],
    typeof Transaction
  >(Commands.UpdateManyTransactions);

  static copyTransactionsTo = collectionCommand<
    ICopyTransactionsToCmd,
    ICmdResult<ICopyTransactionsResult[]>,
    typeof Transaction
  >(Commands.CopyTransactionsTo);

  // Attributes
  // ~~~~

  @attr('date') declare transactionTs: Date;
  @attr('string') transactionType?: string;
  @attr('number') declare qty: number;
  @attr('number') declare onHandAfter: number;
  @attr('number') skuUnitAccountingPrice?: number;
  @attr('string') orderType?: string;
  @attr('string') orderNum?: string;
  @attr('string') orderLine?: string;
  @attr('string') transactionRef?: string;
  @attr('string') externalId?: string;
  @belongsTo('sku', { async: false, inverse: null }) declare sku: SkuModel;

  [Type] = 'transaction' as const;
}
